const BankIcon = ({
  height = "24px",
  width = "24px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
      <svg
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6.88477C12.5523 6.88477 13 6.43705 13 5.88477C13 5.33248 12.5523 4.88477 12 4.88477C11.4477 4.88477 11 5.33248 11 5.88477C11 6.43705 11.4477 6.88477 12 6.88477Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.75 7.92325V6.60025C22.75 5.88425 22.314 5.24125 21.65 4.97525L12.65 1.37525C12.233 1.20825 11.767 1.20825 11.35 1.37525L2.35 4.97525C1.686 5.24125 1.25 5.88425 1.25 6.60025V7.92325C1.25 8.88925 2.034 9.67325 3 9.67325H21C21.966 9.67325 22.75 8.88925 22.75 7.92325ZM21.25 6.60025V7.92325C21.25 8.06125 21.138 8.17325 21 8.17325H3C2.862 8.17325 2.75 8.06125 2.75 7.92325V6.60025C2.75 6.49825 2.812 6.40625 2.907 6.36825L11.907 2.76825C11.967 2.74425 12.033 2.74425 12.093 2.76825L21.093 6.36825C21.188 6.40625 21.25 6.49825 21.25 6.60025Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.994 21.1738L3.514 19.3548C3.545 19.2478 3.643 19.1738 3.754 19.1738H11.5C11.914 19.1738 12.25 18.8378 12.25 18.4238C12.25 18.0098 11.914 17.6738 11.5 17.6738H3.754C2.973 17.6738 2.286 18.1918 2.072 18.9428L1.461 21.0808C1.353 21.4578 1.429 21.8638 1.665 22.1768C1.901 22.4898 2.271 22.6738 2.663 22.6738H11.5C11.914 22.6738 12.25 22.3378 12.25 21.9238C12.25 21.5098 11.914 21.1738 11.5 21.1738H2.994Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.75 10.0008V8.92383C20.75 8.50983 20.414 8.17383 20 8.17383C19.586 8.17383 19.25 8.50983 19.25 8.92383V10.0008C19.25 10.4148 19.586 10.7508 20 10.7508C20.414 10.7508 20.75 10.4148 20.75 10.0008Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.25 10.0008V8.92383C16.25 8.50983 15.914 8.17383 15.5 8.17383C15.086 8.17383 14.75 8.50983 14.75 8.92383V10.0008C14.75 10.4148 15.086 10.7508 15.5 10.7508C15.914 10.7508 16.25 10.4148 16.25 10.0008Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.25 18.4238V8.92383C9.25 8.50983 8.914 8.17383 8.5 8.17383C8.086 8.17383 7.75 8.50983 7.75 8.92383V18.4238C7.75 18.8378 8.086 19.1738 8.5 19.1738C8.914 19.1738 9.25 18.8378 9.25 18.4238Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.75 18.4238V8.92383C4.75 8.50983 4.414 8.17383 4 8.17383C3.586 8.17383 3.25 8.50983 3.25 8.92383V18.4238C3.25 18.8378 3.586 19.1738 4 19.1738C4.414 19.1738 4.75 18.8378 4.75 18.4238Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.04 15.6504C15.44 15.6504 13.329 17.7614 13.329 20.3614C13.329 21.0524 13.757 21.6614 14.558 22.0764C15.403 22.5134 16.72 22.7504 18.04 22.7504C19.36 22.7504 20.676 22.5134 21.521 22.0764C22.323 21.6614 22.75 21.0524 22.75 20.3614C22.75 17.7614 20.639 15.6504 18.04 15.6504ZM18.04 17.1504C19.812 17.1504 21.25 18.5894 21.25 20.3614C21.25 20.4254 21.206 20.4724 21.157 20.5214C21.072 20.6054 20.96 20.6774 20.832 20.7444C20.156 21.0944 19.096 21.2504 18.04 21.2504C16.983 21.2504 15.924 21.0944 15.248 20.7444C15.119 20.6774 15.007 20.6054 14.923 20.5214C14.874 20.4724 14.829 20.4254 14.829 20.3614C14.829 18.5894 16.268 17.1504 18.04 17.1504Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.04 11.25C16.411 11.25 15.089 12.572 15.089 14.2C15.089 15.828 16.411 17.15 18.04 17.15C19.668 17.15 20.99 15.828 20.99 14.2C20.99 12.572 19.668 11.25 18.04 11.25ZM18.04 12.75C18.84 12.75 19.49 13.4 19.49 14.2C19.49 15.001 18.84 15.65 18.04 15.65C17.239 15.65 16.589 15.001 16.589 14.2C16.589 13.4 17.239 12.75 18.04 12.75Z"
          fill="#404040"
        />
      </svg>
  );
};
export default BankIcon;
